import { Suspense } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { getExperimentsContext } from '@adv-frontend/yastore-modules/lib';
import { withDeferred } from '../../lib/hocs';

const WhaleAnimationLazy = loadable(() => import(/* webpackChunkName: "WhaleAnimation" */ './WhaleAnimation'));

/**
 * Анимация кита, отложенная до idle-фазы. Чанк не грузится без флага.
 *
 * @kind component
 */
function WhaleAnimationLoadable() {
    const { experimentsFlags } = getExperimentsContext();

    const isWhaleEnabled = experimentsFlags.enable_whale === 'exp';

    if (!isWhaleEnabled) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <WhaleAnimationLazy />
        </Suspense>
    );
}

export const WhaleAnimationAsync = withDeferred(WhaleAnimationLoadable);
